import { useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { twMerge } from 'tailwind-merge';

interface Props {
  className?: string;
  classNameLabel?: string;
  classNameInput?: string;
  label?: string;
  error?: string;
  onEditorChange?: (value: string) => void;
  name?: string;
  required?: boolean;
  defaultValue?: string;
  value?: string;
}

export function InputEditor(props: Props) {
  const { className, classNameLabel, label, required, name, error, ...prop } = props;
  const editorRef = useRef(null);

  return (
    <div className={className}>
      {label && (
        <label
          htmlFor={name}
          className={twMerge('text-gray_800 text-sm mb-2 block', classNameLabel)}
        >
          {label}
          {required && <span className="text-error ml-1">*</span>}
        </label>
      )}
      <div className="min-h-[400px]">
        <Editor
          apiKey="cb2zqwotin1hagbo6b1g30rl2up7uqryfpexo8by9jwy8056"
          onInit={(_evt, editor) => (editorRef.current = editor)}
          init={{
            height: 400,
            menubar: false,
            plugins: [
              'advlist',
              'autolink',
              'lists',
              'link',
              'image',
              'charmap',
              'preview',
              'anchor',
              'searchreplace',
              'visualblocks',
              'code',
              'fullscreen',
              'insertdatetime',
              'media',
              'table',
              'code',
              'help',
              'wordcount',
            ],
            toolbar:
              'blocks | ' +
              'bold italic forecolor | alignleft aligncenter ' +
              'alignright alignjustify | bullist numlist outdent indent | ' +
              'removeformat | help',
            content_style: `body { font-family: 'Plus Jakarta Sans', sans-serif; font-size:14px }`,
          }}
          {...prop}
        />
      </div>
      {error && <span className="text-sm text-error">{error}</span>}
    </div>
  );
}
